import { keyframes, Stack } from "@mui/material";
import type { FC } from "react";
import { DashboardCardContent } from "web_myplann/Dashboard/Components/DashboardCardContent";
import type { AnimationDirection } from "web_myplann/Dashboard/Hooks/useDashboardAnimation";
import type { DashboardType } from "web_myplann/Dashboard/Types/DashboardType";
import { DASHBOARD_TRANSITION_DURATION_MS } from "web_myplann/Utils/WebViewModel";

const slideOutLeft = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-100%); }
`;

const slideInFromRight = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const slideOutRight = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(100%); }
`;

const slideInFromLeft = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
`;

type Props = {
	dashboardData: DashboardType;
	isAnimating: boolean;
	isPrevious: boolean;
	animationDirection: AnimationDirection;
	isDashboardDetail?: boolean;
	navigateToDashboardDetail?: () => void;
	onTooltipToggle?: (open: boolean) => void;
};

export const DashboardAnimatedContent: FC<Props> = ({
	dashboardData,
	isAnimating,
	isPrevious,
	animationDirection,
	isDashboardDetail,
	navigateToDashboardDetail,
	onTooltipToggle,
}) => {
	const getAnimation = () => {
		if (!isAnimating) return "none";

		if (isPrevious) {
			return animationDirection === "right"
				? `${slideOutLeft} ${DASHBOARD_TRANSITION_DURATION_MS}ms ease-in-out`
				: `${slideOutRight} ${DASHBOARD_TRANSITION_DURATION_MS}ms ease-in-out`;
		}
		return animationDirection === "right"
			? `${slideInFromRight} ${DASHBOARD_TRANSITION_DURATION_MS}ms ease-in-out`
			: `${slideInFromLeft} ${DASHBOARD_TRANSITION_DURATION_MS}ms ease-in-out`;
	};

	return (
		<Stack
			key={dashboardData.id}
			position="absolute"
			width="100%"
			top={0}
			left={0}
			bottom={0}
			sx={{ animation: getAnimation() }}
		>
			<DashboardCardContent
				dashboardData={dashboardData}
				isDashboardDetail={isDashboardDetail}
				navigateToDashboardDetail={navigateToDashboardDetail}
				onTooltipToggle={onTooltipToggle}
			/>
		</Stack>
	);
};
